import React from "react";
import { TwConfirmDialog } from "../../components/tailwind";
import { useTranslation } from "react-i18next";


export default function WarningDialog({ open, text, btnCloseText = "No", isCloseBtn = true, onClose, btnSubmitText = "Yes", isSubmitBtn = true, onSubmit }) {
     const { t, i18n } = useTranslation();
  return (
    <TwConfirmDialog
      dialogOpen={open}
      isCloseBtn={isCloseBtn}
      btnCloseText={btnCloseText}
      isConfirmBtn={isSubmitBtn}
      btnConfirmText={btnSubmitText}
      dialogType="warning"
      dialogTitle={t("bookings.warning")}
      dialogMessage={text}
      onClose={onClose}
      onConfirm={onSubmit}
    />
  )
}
